module.exports = __webpack_public_path__ + "img/delete.a08f4aa1.svg";